import { PAGE_PERMISSION_CODES, PERMISSION_CODES } from '@core-ui/common';
import type {
    AppModule,
    AppSubmodule,
    ExposedMenu,
} from '@moniebook-web/components/widgets/sidebar';
import { FileHistoryLine } from '@moniebook-web/icons/document/file-history-line';
import { FileTextFill } from '@moniebook-web/icons/document/file-text-fill';
import { CoinLine } from '@moniebook-web/icons/finance/coin-line';
import { More } from '@moniebook-web/icons/sidebar-rail/more';
import {
    ApplicationModule,
    MENU_SECTIONS,
    SETTINGS_SECTIONS,
} from '@moniebook-web/types';

export const businessMgtMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Branches',
            to: '/dashboard/settings/branches',
            order: 4,
            accessCodeList: PAGE_PERMISSION_CODES.BRANCHES,
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Branch Groups',
            to: '/dashboard/settings/branch-groups',
            order: 4,
            accessCodeList: PAGE_PERMISSION_CODES.BRANCH_GROUPS,
            featureFlag: 'moniebook.pos.enableBranchGroupsFeature',
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Roles & permissions',
            to: '/dashboard/settings/roles',
            order: 5,
            accessCodeList: [PERMISSION_CODES.MANAGE_ROLE],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Staff',
            to: '/dashboard/settings/staff',
            order: 6,
            accessCodeList: [PERMISSION_CODES.MANAGE_STAFF],
            showInSettings: true,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            name: 'Collections',
            to: '/dashboard/collections',
            icon: <CoinLine />,
            order: 6,
            accessCodeList: [PERMISSION_CODES.VIEW_COLLECTION_ACCOUNT],
            featureFlag: 'moniebook.pos.enableCollectionAccount',
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 6,
            accessCodeList: PAGE_PERMISSION_CODES.ACTIVITY_LOG,
            featureFlag: 'moniebook.pos.auditLogs',
            name: 'Activity Log',
            to: '/dashboard/activity-logs',
            icon: <FileTextFill />,
        },
    ],
    modules: [
        {
            id: ApplicationModule.MORE,
            name: 'More',
            order: 8,
            icon: <More />,
            backgroundColor: '#CBFBF1',
            foregroundColor: '#0D9488',
        },
    ] as AppModule[],
    subModules: [
        {
            parentId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Branches',
            to: '/dashboard/settings/branches',
            order: 4,
            accessCodeList: PAGE_PERMISSION_CODES.BRANCHES,
            showInSettings: true,
        },
        {
            parentId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Branch Groups',
            to: '/dashboard/settings/branch-groups',
            order: 4,
            accessCodeList: PAGE_PERMISSION_CODES.BRANCH_GROUPS,
            featureFlag: 'moniebook.pos.enableBranchGroupsFeature',
            showInSettings: true,
        },
        {
            parentId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Roles & permissions',
            to: '/dashboard/settings/roles',
            order: 5,
            accessCodeList: [PERMISSION_CODES.MANAGE_ROLE],
            showInSettings: true,
        },
        {
            parentId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Staff',
            to: '/dashboard/settings/staff',
            order: 6,
            accessCodeList: [PERMISSION_CODES.MANAGE_STAFF],
            showInSettings: true,
        },
        {
            parentId: ApplicationModule.MORE,
            name: 'Collections',
            to: '/dashboard/collections',
            icon: <CoinLine />,
            order: 6,
            accessCodeList: [PERMISSION_CODES.VIEW_COLLECTION_ACCOUNT],
            featureFlag: 'moniebook.pos.enableCollectionAccount',
        },
        {
            parentId: ApplicationModule.MORE,
            order: 6,
            accessCodeList: PAGE_PERMISSION_CODES.ACTIVITY_LOG,
            featureFlag: 'moniebook.pos.auditLogs',
            name: 'Activity Log',
            to: '/dashboard/activity-logs',
            icon: <FileHistoryLine />,
        },
    ] as AppSubmodule[],
};
